import { SUCCESS } from "../../../../../constants/action-postfix";
import { STAFF_INFO_REQUEST } from "../../staffInfoReducer";


const initialState = null;

export const awardsReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${STAFF_INFO_REQUEST}${SUCCESS}`:
            return action.payload.awards;
        default:
            return state;
    }
};
